import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { Route, Routes } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes.ts'

import citizenshipStore from 'shared/store/citizenship-store'
import { EmptyPage } from 'shared/ui/empty-page'
import { Loader } from 'shared/ui/loader'

import { CertificateStatus } from './pages/certificate-status'
import { CheckPage } from './pages/check'
import { Confirm } from './pages/confirm/index.ts'
import { FormPurchase } from './pages/form/index.ts'

const PurchaseForm = observer(() => {
  const { t } = useTranslation()

  useEffect(() => {
    void citizenshipStore.ensureAviaCitizenships()
  }, [])

  const hasCitizenshipsLoadError =
    citizenshipStore.citizenshipAvia === null &&
    citizenshipStore.aviaStatus === 'error'
  const isCitizenshipsInitialLoading =
    citizenshipStore.citizenshipAvia === null && !hasCitizenshipsLoadError

  if (hasCitizenshipsLoadError) {
    return (
      <EmptyPage
        title={t('error')}
        subTitle={t('error_des')}
        buttonText={t('try_again')}
        onClick={() => void citizenshipStore.ensureAviaCitizenships()}
      />
    )
  }

  if (isCitizenshipsInitialLoading) {
    return <Loader marginTop={150} />
  }

  return (
    <Routes>
      <Route
        path={RoutingPaths.avia.purchase.page()}
        element={<FormPurchase />}
      />

      <Route
        path={RoutingPaths.avia.purchase.check.base()}
        element={<Confirm />}
      />

      <Route
        path={RoutingPaths.avia.purchase.tickerDetail.base()}
        element={<CheckPage />}
      />

      <Route
        path={RoutingPaths.avia.purchase.tickerCertificate.base()}
        element={<CertificateStatus />}
      />
    </Routes>
  )
})

export default PurchaseForm
